export const languagesList = {
  en: "English",
  fr: "French",
  es: "Spanish",
}
